import classNames from 'classnames'
import type { CommonProps } from '../@types/common'
import type { ElementType, Ref } from 'react'

export interface SkeletonProps extends CommonProps {
    animation?: boolean
    asElement?: ElementType
    height?: string | number
    ref?: Ref<ElementType>
    variant?: 'block' | 'circle'
    width?: string | number
}

const Skeleton = (props: SkeletonProps) => {
    const {
        animation = true,
        asElement: Component = 'span',
        className,
        height,
        ref,
        style,
        variant = 'block',
        width,
    } = props

    return (
        <Component
            ref={ref}
            className={classNames(
                'skeleton relative overflow-hidden bg-gray-200',
                variant === 'circle' && 'rounded-full',
                variant === 'block' && 'rounded-lg',
                animation && 'animate-pulse',
                className,
            )}
            style={{
                width,
                height,
                ...style,
            }}
        >    {animation && (
                <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 opacity-30 animate-shimmer" />
            )}</Component>
    )
}

export default Skeleton
